import { render, staticRenderFns } from "./ProductOrdering.vue?vue&type=template&id=0a546f4d&scoped=true"
import script from "./ProductOrdering.vue?vue&type=script&lang=js"
export * from "./ProductOrdering.vue?vue&type=script&lang=js"
import style0 from "./ProductOrdering.vue?vue&type=style&index=0&id=0a546f4d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a546f4d",
  null
  
)

export default component.exports